import axios from 'axios';
import { ArticleV1, ArticleContentMetaV2 } from '@ilteducation/content-registry-types';

let serviceUrl = '';
serviceUrl = process.env.VUE_APP_AI_SERVICE_API_URL ?? serviceUrl;
serviceUrl = serviceUrl.endsWith('/') ? serviceUrl : `${serviceUrl}/`;

const getHeaders = () => ({
  'Content-Type': 'application/json',
});

export const generateExercise = async (
  articleId: string,
  questionType: string,
  realm: string | undefined,
  language: string | undefined,
  path: string | undefined,
): Promise<void> => {
  const url = `${serviceUrl}generateQuestions`;

  axios
    .request({
      url,
      method: 'POST',
      headers: getHeaders(),
      data: {
        contentId: articleId,
        realm,
        questionType,
        language,
        path,
      },
    })
    .then((response) => response.data);
};

const isArticleContentMetaV2 = (val: any): val is ArticleContentMetaV2 => val !== undefined && val.path !== undefined;

export const generateSummary = async (article: ArticleV1): Promise<void> => {
  const url = `${serviceUrl}generateSummary`;
  if (!isArticleContentMetaV2(article?.contentMeta)) console.log('No path for article', article.id);
  else
    axios
      .request({
        url,
        method: 'POST',
        headers: getHeaders(),
        data: {
          id: article.id,
          path: article.contentMeta.path,
          realm: article.realm,
          language: article.content?.language,
        },
      })
      .then((response) => response.data);
};
